'use client';
import { Box, Stack, Typography } from '@mui/material'
import { useEffect, useRef } from 'react'
import lottie from 'lottie-web';

export default function NoData({ text, width = 300, height = 50, loading }) {
  const animationContainer = useRef(null);

  useEffect(() => {
    lottie.loadAnimation({
      container: animationContainer.current,
      renderer: 'svg',
      loop: false,
      autoplay: true,
      path: '/json/noRecord.json'
    });
    return () => animationContainer.current = null
  }, []);


  return (
    <Stack sx={{
      height: `${height}vh`,
      mt: 2,
      borderRadius: 2,
      justifyContent: "center",
      backgroundColor: (theme) => theme.palette.background.default
    }}>
      {
        loading &&
        <Box ref={animationContainer} sx={{ width: width, margin: "10px auto" }}> </Box>
      }
      <Typography variant={"subtitle1"} align="center">{text || "No data available!"}</Typography>
    </Stack>
  )
}
